import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'courseValidity'})
export class CourseValidityPipe implements PipeTransform {
  transform(value: number): string {
    if (value != null) {
      return value + '';
    }

    return 'Sempre Valido';
  }
}
